export default {
    namespaced: true,
    state: {
        //坐席信息
        seatPost: {},
        // 按钮状态
        refreshState: {
            isCheck: false, //是否登录
            isLeisure: false, //是否示闲
            isDial: false, //是否在通话中
            isHold: false, //是否保持
        },
        //来电弹屏dialog
        incomingTelVisible: false,
        //来电弹屏需要传输的数据
        incomingTelData: {},
    },
    mutations: {
        setSeatPost(state, data) {
            state.seatPost = data;
        },
        setRefreshState(state, data) {
            state.refreshState = data;
        },
        setIncomingTelVisible(state, data) {
            state.incomingTelVisible = data;
        },
    },
    actions: {
        setSeatPostAction({commit}, data) {
            commit('setSeatPost', data)
            console.log("setSeatPost :", data)
        },
        setRefreshStateAction({commit}, data) {
            commit('setRefreshState', data)
            console.log("setRefreshState:", data)
        },
        setIncomingTelVisibleAction({commit}, data) {
            commit('setIncomingTelVisible', data)
            console.log("setIncomingTelVisible:", data)
        },
    },
}
